export default __webpack_public_path__ + "static/media/component003Lady-right.631e7320.png";